<template>
  <div class="row">
    <div class="top-bar" @click="closeAll">
      <div class="top-bar-left"><p>Identity Management</p></div>
      <burger/>
      <div class="top-bar-right">
        <div class="sml-add-user">
          <a href="#" class="top-bar-add" @click.prevent="showForm()">Add new user</a>
        </div>
        <div class="top-bar-filters">
          <div class="top-bar-filter top-bar-filter-fullheight">
            <div class="container-fluid">
              <search-filter @search="setFilter('query', $event)" />
            </div>
          </div>
          <div class="top-bar-filter top-bar-filter-list">
            <p>Filter:</p>
            <role-filter :type="filters.type" @role="setFilter('type', $event)" />
            <location-filter :location="filters.location_id" @location="setFilter('location_id', $event)" />
            <active-filter :active="filters.active" @status="setFilter('active', $event)" />
          </div>
          <!-- <div class="top-bar-filter sml-third-filter">
            <p>Action:</p>
            <div class="dropdown" style="float:left;">
              <button class="dropbtn attendance-dropdown">
                <p><span v-text="currentaction"></span>&nbsp;<i class="fas fa-caret-down"></i></p>
              </button>
              <div class="dropdown-content">
                <a href="#" @click="updateAction('Delete')">Delete</a>
                <a href="#" @click="updateAction('Activate')">Activate</a>
                <a href="#" @click="updateAction('Deactivate')">Deactivate</a>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="container-main">
      <div class="container-fluid right-container" data-simplebar id="items-container">
        <div class="left-side">
          <add-student-profile @close="create = false" @saved="getItems(); create = false"  v-if="create"/>
          <student-profile :user="user" @close="edit = false" @saved="getItems(); edit = false"  v-if="edit"/>
          <v-infinite-scroll :loading="$store.state.loading" @bottom="loadMore" :offset='20' style="max-height: 90vh; overflow-y: scroll;">
            <table class="table items-table">
              <tbody>
                <tr class="item" v-for="(user, key) in users" :key="key">
                  <td class="avatar" @click.prevent="showForm(user)">
                    <user-photo :user="user" />
                  </td>
                  <td @click.prevent="showForm(user)">
                    <p>Name</p>
                    <p>{{ user.first_name }} {{ user.last_name }}</p>
                  </td>
                  <td class="col-id" @click.prevent="showForm(user)">
                    <p>ID</p>
                    <p>{{ user.id }}</p>
                  </td>
                  <td class="col-status ie-col-status-row" @click.prevent="showForm(user)">
                    <p>Role</p>
                    <div class="row">
                      <div class="col">
                        <p class='identified-status'>{{ roles[user.type] }}</p>
                      </div>
                      <div class="col">
                        <div class="identified-status-circle"></div>
                      </div>
                    </div>
                  </td>
                  <td @click.prevent="showForm(user)">
                    <p>Last action</p>
                    <p>{{ moment(user.last_auth).format('MMM DD / h:mm a') }}</p>
                  </td>
                  <td class="col-id" @click.prevent="showForm(user)">
                    <p>Location seen</p>
                    <p>{{ user.event_last_seen ? user.event_last_seen.camera.location.name : 'No location' }}</p>
                  </td>
                  <td class="col-flag sml-col sml-large-item-currentactions text-center actions-col">
                    <router-link :to="`/attendance/tracking?user_id=${user.id}`">
                      <img src=".././assets/images/archive_black.svg" alt="" data-toggle="tooltip" data-placement="bottom" title="Attendance">
                      <span><img src=".././assets/images/archive_black.svg" alt=""> Attendance</span>
                    </router-link>
                    <router-link :to="`/events?user_id=${user.id}`">
                      <img src=".././assets/images/alerts_black.svg" alt="" data-toggle="tooltip" data-placement="bottom" title="Events">
                      <span><img src=".././assets/images/alerts_black.svg" alt=""> Events</span>
                    </router-link>
                    <a href="#" @click.prevent="toggleUserActive(key, !user.active)" v-if="!user.active">
                      <img src=".././assets/images/activate.svg" alt="" data-toggle="tooltip" data-placement="bottom" title="Activate">
                      <span><img src=".././assets/images/activate.svg" alt=""> Activate</span>
                    </a>
                    <a href="#" @click.prevent="toggleUserActive(key, !user.active)" v-else>
                      <img src=".././assets/images/deactivate.svg" alt="" data-toggle="tooltip" data-placement="bottom" title="Deactivate">
                      <span><img src=".././assets/images/deactivate.svg" alt=""> Deactivate</span></a>
                    <a href="#" @click.prevent="deleteUser(key)">
                      <img src=".././assets/images/trash.svg" alt="" data-toggle="tooltip" data-placement="bottom" title="Delete">
                      <span><img src=".././assets/images/trash.svg" alt=""> Delete</span>
                    </a>
                  </td>
                  <!-- <td class="text-center">
                    <ul class="unstyled centered">
                      <li>
                        <input class="styled-checkbox" :id="'styled-checkbox-' +  key" type="checkbox" :value="'value'+key"
                          v-model="checked">
                        <label :for="'styled-checkbox-' +  key"></label>
                      </li>
                    </ul>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </v-infinite-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AddStudentProfile from '@/views/AddStudentProfile';
  import StudentProfile from '@/views/StudentProfile';
  import UserPhoto from '@/components/users/Photo';
  import SearchFilter from '@/components/filters/Search';
  import ActiveFilter from '@/components/filters/Active';
  import LocationFilter from '@/components/filters/Location';
  import RoleFilter from '@/components/filters/Role';
  import Burger from '@/components/Burger';

  export default {
    name: 'StudentManagement',
    components: {
      AddStudentProfile,
      StudentProfile,
      SearchFilter,
      UserPhoto,
      ActiveFilter,
      LocationFilter,
      RoleFilter,
      Burger
    },
    data() {
      return {
        create: false,
        edit: false,
        load: true,
        users: [],
        user: {},
        filters: {
          'query': null,
          'active': 1,
          'location_id': null,
          type: null,
          'start': 0,
          'limit': 20,
        },
        currentaction: 'Action',
        checked: [],
      };
    },
    mounted() {
      this.getItems();
      this.closeUserForm();
    },
    computed: {
      roles() {
        return this.$store.state.settings.data.user_types;
      },
    },
    methods: {
      showForm(user = {}) {
        if (Object.keys(user).length) {
          this.user = user;
          this.edit = true;
          this.create = false;

          return;
        }

        this.create = true;
        this.edit = false;
      },
      updateAction(currentaction) {
        if (this.checked.length > 0) {
          confirm(`Are you sure you want to ${currentaction} item?`);
        }
      },
      getFilters() {
        let filters = [];//['loggable=0'];

        window._.forIn(this.filters, function (value, index) {
          if (value != null) {
            filters.push(`${index}=${value}`);
          }
        });

        return filters.join('&');
      },
      getItems() {
        this.load = true;
        this.resetPagination();

        this.axios.get(`/users?${this.getFilters()}`)
          .then(response => {
            if (!response.data.users.length) {
              this.load = false;
            }

            this.users = response.data.users;
          });
      },
      loadMore() {
        if (!this.load) {
          return;
        }

        this.filters.start += (!this.filters.start ? 20 : 10);
        this.filters.limit = 10;

        this.axios.get(`/users?${this.getFilters()}`)
          .then(response => {
            if (!response.data.users.length) {
              this.load = false;
            }

            for (let i in response.data.users) {
              this.users.push(response.data.users[i]);
            }
          });
      },
      toggleUserActive(index) {
        let confirmationMessage = 'Are you sure you want to activate item?';

        if (this.users[index].active) {
          confirmationMessage = 'Are you sure you want to deactivate item?';
        }

        if(confirm(confirmationMessage)) {
          let activeStatus = !this.users[index].active;

          let data = {
            user_id: this.users[index].id,
            fields: ["active"],
            values: [activeStatus]
          };

          this.$store.dispatch('users/updateUser', data)
            .then(() => {
              this.users[index].active = activeStatus;
              this.$snotify.success("Active status updated");
            });
        }
      },
      deleteUser(index) {
        if (confirm('Are you sure you want to delete user?')) {
          this.$store.dispatch('users/deleteUser', { user_id: this.users[index].id })
            .then(() => {
              this.$snotify.success('User successfully deleted!');
              this.users.splice(index, 1);
            });
        }
      }
    },
  };
</script>
